import React from 'react';
import { Box, Text } from 'grommet';
import { normalizeColor } from 'grommet/utils';
import { Like } from 'grommet-icons';
import styled, { css } from 'styled-components';
import { ScanTarget } from '@/components/home/ScanTarget';

const LeftCircle = styled.div`
  ${({ theme }) => css`
    position: absolute;
    background-color: ${normalizeColor(`status-error`, theme)};
    left: -120px;
    bottom: -120px;
    border-radius: 100%;
    height: 30vw;
    width: 30vw;
    max-height: 400px;
    max-width: 400px;
  `}
`;

const RightCircle = styled.div`
  ${({ theme }) => css`
    position: absolute;
    border-width: ${theme.global.borderSize.xsmall};
    border-style: solid;
    border-color: #3db6ea;
    right: -150px;
    top: -200px;
    border-radius: 100%;
    height: 35vw;
    width: 35vw;
    max-height: 450px;
    max-width: 450px;
  `}
`;

// TODO: Standardize colors
export const CTA = () => (
  <Box
    id="cta"
    round
    fill="horizontal"
    height="medium"
    background="brand"
    alignSelf="center"
    justify="center"
    direction="row"
    pad="large"
    overflow="hidden"
    style={{ position: `relative` }}
  >
    <LeftCircle />
    <Box align="center" justify="center" gap="small">
      <Box pad="small" border={{ color: `#3db6ea` }} round="full">
        <Box pad="medium" background="#3db6ea" round="full" animation="jiggle">
          <Like size="large" color="white" />
        </Box>
      </Box>
      <Text size="xlarge" color="white" weight="bold" textAlign="center">
        100% Free Web Scan with Instant Results
      </Text>
      <ScanTarget
        boxProps={{
          pad: `none`,
          elevation: `none`,
          alignSelf: `center`,
          background: `light-1`,
          border: undefined,
          margin: { top: `small` },
        }}
        buttonProps={{ color: `text` }}
      />
    </Box>
    <RightCircle />
  </Box>
);
